module.exports = {
    'A': '#cbf751',
    'C': '#5ec0cc',
    'G': '#ffdf59',
    'T': '#b51f16',
    'U': '#b51f16'
  };



//////////////////
// WEBPACK FOOTER
// ./~/biojs-vis-seqlogo/src/colors/dna.js
// module id = 101
// module chunks = 0